export default "__VITE_ASSET__VYcADDFN__"